import React from 'react';
import { get } from 'lodash';
import { format } from 'date-fns';
import getSymbolFromCurrency from 'currency-symbol-map';
import { getBillingToken } from '~/tools/stripe';
import PaygateForm from '~/components/Paygate';
import { subscribe, cancelSubscribe} from '~/redux/user/subscription';
import { updateUserCard, updateStripePayment } from '~/redux/user/helpers';
import StripeCCForm from './StripeCCForm';
import SSLCommerz from '~/components/SSLCommerz';
import CCAvenueNS from '~/components/CCAvenueNS2';
import JusPay from '~/components/JusPay';
import MercadoForm from '~/components/Mercado';
import getCountryCode from '~/tools/userEnvironment/getCountryCode';
import { isSite } from '~/tools/isSite'
import getPriceFormat from "~/tools/getPriceFormat"
import { StripeJS } from './StripeCCForm/StripeJS';
import { AmazonJS } from '~/components/AmazonPay/AmazonJS'
import Spinner from '~/components/Spinner';
import getQueryVariable from '~/tools/getQueryVariable';

import { getToken } from '~/redux/user/tokens'
import './style.scss';
import Paypal from '~/components/Paypal'
import { gtmTagEcommerceEvent } from '~/tools/analytics/gtmTags';
import {getActivePaymentMethod} from '~/services/userService';

class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = { form: null };
    this.webSocketBaseUrl = window.settings.apiBaseUrl && window.settings.apiBaseUrl.replace('api','ws').replace('https','wss');
  }
  getVal(key) {
    return get(this.props.metadataMap, key)
  }

  async componentDidMount() {
    await StripeJS();
    await AmazonJS();
    getActivePaymentMethod(this.props.paymentHandler).then((m) => {
      this.setState({
        form: m
      })
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.form !== prevState.form) {
      const override = getQueryVariable('paymentMethod');
      var form = override || this.state.form;
      /*********** Start GTM Event *************/
      gtmTagEcommerceEvent(this.props, 'Customer intiated from the subscription plan', form)
      /*********** End GTM Event *************/
    }
  }

  render() {
    if (!this.state.form)
      return null;

    // var searchParams = (new URL(document.location)).searchParams;
    // var override = searchParams && searchParams.get('paymentMethod');
    const override = getQueryVariable('paymentMethod');
    var form = override || this.state.form;

    switch (form) {
      case 'ccavenue':
        return (this.ccavForm());
      case 'juspay':
        return (this.jusPayForm());
      case 'mercadopago':
        return (this.mercadoForm());
      case 'sslcommerz':
        return (this.sslForm());
      case 'paygate':
        return (this.paygateForm());
      case 'payPal':
      return (this.paypalForm());
      default:
        return (this.stripeForm());
    }
  }

  offerCodeEl() {
    return (
      <div className="offer-code">
        <i className="ion-ios-pricetags-outline"></i>
        {this.props.offerCode ? (
          <span>{this.getVal('billingOfferAppliedLeft')} "{this.props.offerCode.displayName || this.props.offerCode.name}" {this.getVal('billingOfferAppliedRight')} </span>
        ) : (
            <span>{this.getVal('billingNoCode')}</span>
          )}
        <span className="link-button site-color site-border-color" onClick={_ => this.props.editPromo()}>{this.getVal('billingEditOffer')}</span>
      </div>
    );
  }

  loadingScreen = () => {
    this.props.overlay({ styles: { backgroundColor: '#777575CC', zIndex: 2 }, loading: true, message: this.getVal('paymentProcessingMessage') || 'Please wait while we confirm your payment'})
  }

  stripeForm() {
    const { plan, editPlan } = this.props
    const pd = plan && plan.planDetails && plan.planDetails[0] || {}
    let planDetails = pd.description || plan.description
    let expiration = this.props.firstPayment && format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY") || ''
    let priceFormat = pd && getPriceFormat(pd, plan) || 'N/A'
    planDetails= planDetails && planDetails.replace(/\[deadline\]/g, expiration)
    planDetails= planDetails && planDetails.replace(/\[price\]/g, priceFormat)

    return <div className="billing stripe-container">
        <div className="plan-title">
          {pd.title || plan.name}
          { editPlan && 
            <span className="link-button site-color site-border-color edit-plan" onClick={() => editPlan()}>
             {this.getVal('editPlan')}
            </span> }
        </div>
        {isSite('monumental') || isSite('staging-mse') ?
          <div className="descBox" dangerouslySetInnerHTML={{__html: planDetails}} />
        :
          <div className="plan-details" dangerouslySetInnerHTML={{__html: planDetails}} />
        }
        
        {this.props.firstPayment && !isSite('monumental') && !isSite('staging-mse') && <div className="desc">
            <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
            <span className="price">
              &nbsp;
              {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
          {this.props.firstPayment.amount.toFixed(2)}
          </span> {this.getVal('verifyTax')} {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
        </div>}
        {this.offerCodeEl()}
        <div className="stripe-form-wrapper">
        <StripeCCForm 
          onToken={(token, stripeObj) => {
            return getBillingToken(token, stripeObj)
            .then(billingToken => {
              let userObj = this.props.user;
              userObj.billingInfo = billingToken;
              updateUserCard(userObj);
              if (this.props.purchase) {
                if(!this.props.updateCard) {
                  this.props.saveToken(billingToken)
                }
                this.props.success()
              }
              else {
                if(window.settings.paymentProviders.stripe && window.settings.paymentProviders.stripe.transactionalPayment) {
                  this.loadingScreen();
                  subscribe({
                    plan: this.props.plan,
                    billingToken: billingToken,
                    offerCode: this.props.offerCode && this.props.offerCode.code
                  }).then(()=> {
                    getToken().then((token) => {
                      var paymentSocket = new WebSocket(this.webSocketBaseUrl + "/notification?token="+ token)
                      var isPaymentinProcess = false;
                      var subscribeMessage =  {
                        "action": "subscribe",
                        "eventType": "SUBSCRIPTION",
                        "token" : token
                      }
                      var ref = this;
                      paymentSocket.onopen = function() {
                        console.log('socket opened')
                        paymentSocket.send(JSON.stringify(subscribeMessage));
                        setTimeout(()=>{
                          if(!isPaymentinProcess){
                            paymentSocket.close();
                            ref.props.success(null, "InProcess");
                            cancelSubscribe();
                          }
                        },60000)
                      }
                      paymentSocket.onmessage = function (event) {
                        console.log("socket message received");
                        isPaymentinProcess = true;
                        var paymentData = event.data && JSON.parse(event.data)
                        if(paymentData.event == "subscription" && paymentData.status == "completed") {
                          ref.props.success();
                        } else {
                          ref.props.success(null, "Failed");
                          cancelSubscribe();
                        }
                        paymentSocket.close();
                      }
                      paymentSocket.onerror = function () {
                        console.log("connection error");
                        isPaymentinProcess = true;
                        paymentSocket.close();
                        ref.props.success(null, "InProcess");
                        cancelSubscribe();
                      }
                    })
                  },()=> {
                    this.props.success(null, "Failed");
                    cancelSubscribe();
                  })
                } else {
                  subscribe({
                    plan: this.props.plan,
                    billingToken: billingToken,
                    offerCode: this.props.offerCode && this.props.offerCode.code
                  }).then(
                    () => this.props.success(),
                    () => {
                      this.props.success(null, "Failed")
                      cancelSubscribe();
                    }
                  )
                }
              }
            })
            // .then(data => this.props.success(data));
            }
          }
          submitCaption={this.props.updateCard ? this.getVal('billingSaveChanges') : (this.props.buttonCaption || this.getVal('billingSubscribeNow'))}
          processingCaption = {this.getVal('paymentProcessing')}
          fields={this.props.metadataMap}
          firstPayment={this.state.firstPayment}
          {...this.props}
        />
        </div>
  
        <div className="legal-texts" dangerouslySetInnerHTML={{ __html: this.getVal('billingAgreement') }} />
      </div>;
  }

  paypalForm() {
    return (
      <React.Fragment>
        <div className="paypal-button-single">
          <Paypal
            currentPlan={this.props.plan}
            overlay={this.props.overlay}
            subscribe={(id) => subscribe({
            vlTransactionId: id,
            subscription: 'paypal',
            plan: this.props.plan, 
            offerCode:
              this.props.offerCode &&
              this.props.offerCode.code
            }).then(data => this.props.success(data))}
          />
        </div>
      </React.Fragment>
		  ) 
  }

  ccavForm() {
    var plan = this.props.plan;
    var pd = plan.planDetails[0];

    return (
      <div className="billing ccav-container">
        <div className="plan-info">
          <div className="title">
            {pd.title || plan.name}
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={() => this.props.editPlan()}>
              {this.getVal('editPlan')}
            </span>
          </div>
          <div className="desc">
            <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
            &nbsp;{getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}{pd.recurringPaymentAmount} {this.getVal('ONSeparator')} {format(Date.now(), 'MM/DD/YYYY')}
          </div>
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            {this.props.offerCode ? (
              <span>{this.getVal('billingOfferAppliedLeft')} "{this.props.offerCode.displayName || this.props.offerCode.name}" {this.getVal('billingOfferAppliedRight')} </span>
            ) : (
                <span>{this.getVal('promoHeading')}</span>
              )}
            <span className="link-button site-color site-border-color" onClick={_ => this.props.editPromo()}>
              {this.props.offerCode ? this.getVal('editPromo') : this.getVal('addPromo')}
            </span>
          </div>
        </div>
        <CCAvenueNS plan={this.props.plan} metadataMap={this.props.metadataMap} />
      </div>
    );
  }

  jusPayForm() {
    var plan = this.props.plan;
    var pd = plan.planDetails[0];

    return (
      <div className="billing ccav-container">
        <div className="plan-info">
          <div className="title">
            {pd.title || plan.name}           
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={() => this.props.editPlan()}>
              {this.getVal('editPlan')}
            </span>        
          </div>
          {this.props.firstPayment && <div className="desc">
            <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
            <span className="price">
              &nbsp;
                  {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
              {this.props.firstPayment.amount.toFixed(2)}
            </span> {this.getVal('ONSeparator')} {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
          </div>}
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            {this.props.offerCode ? (
              <span>{this.getVal('billingOfferAppliedLeft')} "{this.props.offerCode.displayName || this.props.offerCode.name}" {this.getVal('billingOfferAppliedRight')} </span>
            ) : (
                <span>{this.getVal('promoHeading')}</span>
              )}
            <span className="link-button site-color site-border-color" onClick={_ => this.props.editPromo()}>
              {this.props.offerCode ? this.getVal('editPromo') : this.getVal('addPromo')}
            </span>
          </div>
        </div>
        { !this.props.firstPayment && <div className="loading-centered"><Spinner /></div>}
        { this.props.firstPayment && this.props.firstPayment.amount && <JusPay firstPayment = {this.props.firstPayment} plan={plan} metadataMap={this.props.metadataMap} continue={this.props.continue} />}
      </div>
    );
  }

  paygateForm() {
    var {plan, editPlan} = this.props;
    var pd = (plan && plan.planDetails && plan.planDetails[0]) || {};

    return (
      <div className="billing ccav-container paygate-form">
        <div className="plan-info">
          <div className="title">
            { pd.title || plan.name }
            {editPlan &&
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={ () => this.props.editPlan() }>
              {this.getVal('editPlan')}
            </span>}
          </div>
          <div className="desc">
            <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
            &nbsp;{ getSymbolFromCurrency(pd.recurringPaymentCurrencyCode) }{ pd.recurringPaymentAmount } {this.getVal('ONSeparator')} { this.props.firstPayment && this.props.firstPayment.nextBillingDate && format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
          </div>
        </div>
        <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            { this.props.offerCode ? (
              <span>{this.props.metadataMap.billingOfferAppliedLeft} "{ this.props.offerCode.displayName || this.props.offerCode.name }" {this.props.metadataMap.billingOfferAppliedRight} </span>
            ) : (
              <span>{this.props.metadataMap.promoHeading}</span>
            ) }
            <span className="link-button site-color site-border-color" onClick={ _ => this.props.editPromo() }>
              { this.props.offerCode ? this.props.metadataMap.editPromo : this.props.metadataMap.addPromo }
            </span>
          </div>
        <PaygateForm plan={ plan } metadataMap={this.props.metadataMap} {...this.props}/>
      </div>
    );
  }

  sslForm() {
    var plan = this.props.plan;
    var pd = plan.planDetails[0];

    return (
      <div className="billing ccav-container">
        <div className="plan-info">
          <div className="title">
            {pd.title || plan.name}
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={() => this.props.editPlan()}>
              {this.getVal('editPlan')}
            </span>
          </div>
          <div className="desc">
            <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
            &nbsp;{getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}{pd.recurringPaymentAmount} on {format(Date.now(), 'MM/DD/YYYY')}
          </div>
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            {this.props.offerCode ? (
              <span>{this.getVal('billingOfferAppliedLeft')} "{this.props.offerCode.displayName || this.props.offerCode.name}" {this.getVal('billingOfferAppliedRight')} </span>
            ) : (
                <span>{this.getVal('promoHeading')}</span>
              )}
            <span className="link-button site-color site-border-color" onClick={_ => this.props.editPromo()}>
              {this.props.offerCode ? this.getVal('editPromo') : this.getVal('addPromo')}
            </span>
          </div>
        </div>
        <SSLCommerz plan={plan} metadataMap={this.props.metadataMap} />
      </div>
    );
  }

  mercadoForm() {
    const plan = this.props.plan;
    const pd = plan.planDetails && plan.planDetails[0] || {};

    return (
      <div className="billing mercado-container">
        <div className="plan-info">
          <div className="plan-title">
            {plan.name}
            <span
              className="link-button site-color site-border-color edit-plan"
              onClick={ () => this.props.editPlan() }>
              {this.props.metadataMap.billingEditOffer}
            </span>
          </div>
          <div className="desc">
            <span className="first-payment">{this.props.metadataMap.firstPaymentHead}</span>
            &nbsp;{ getSymbolFromCurrency(pd.recurringPaymentCurrencyCode) }{ pd.recurringPaymentAmount } {this.props.metadataMap.ONSeparator} { format(Date.now(), 'MM/DD/YYYY') }
          </div>
          <div className="means-of-payments">
            <img
              src="https://imgmp.mlstatic.com/org-img/banners/ar/medios/785X40.jpg"
              title="MercadoPago - Means of payment"
              alt="MercadoPago - Means of payment"
            />
          </div>
          <div className="offer-code">
            <i className="ion-ios-pricetags-outline"></i>
            { this.props.offerCode ? (
              <span>{this.props.metadataMap.billingOfferAppliedLeft} "{ this.props.offerCode.displayName || this.props.offerCode.name }" {this.props.metadataMap.billingOfferAppliedRight} </span>
            ) : (
              <span>{this.props.metadataMap.promoHeading}</span>
            ) }
            <span className="link-button site-color site-border-color" onClick={ _ => this.props.editPromo() }>
              { this.props.offerCode ? this.props.metadataMap.editPromo : this.props.metadataMap.addPromo }
            </span>
          </div>
        </div>
        <MercadoForm plan={ plan } success={this.props.success} metadataMap={this.props.metadataMap}  {...this.props}/>
      </div>
    )
  }

}

export default Billing;